import React, {ReactNode} from "react";
import {
    DashboardOutlined,
    FundProjectionScreenOutlined,
    LogoutOutlined,
    MenuUnfoldOutlined,
    CodeSandboxOutlined,
    SettingFilled,
    UserOutlined,
    UsergroupAddOutlined,
    ScheduleOutlined,
} from "@ant-design/icons";
import Counter from "./Sandbox/Counter";
import Dashboard from "./Dashboard";
import Settings from "./Settings";
import Applications from "./Applications";
import Account from "./Account";
import ShowPortraits from "./Sandbox/ShowPortraits";
import TaskList from "../features/tasks/TaskList";

export type MenuItem = {
    key: string;
    label: string;
    children?: MenuItem[];
    hidden?: boolean;
    onlyAdmin?: boolean;
    icon?: ReactNode;
    page?: ReactNode;
}

const menuItems: MenuItem[] = [
    {
        key: '1',
        label: 'Menu Principal',
        onlyAdmin: false,
        icon: <MenuUnfoldOutlined/>,
        children: [
            {
                key: '1-01',
                label: 'Tableau de bord',
                icon: <DashboardOutlined/>,
                page: <Dashboard/>,
            },
            {
                key: '1-02',
                label: 'Applications',
                icon: <FundProjectionScreenOutlined/>,
                page: <Applications/>
            },
            {
                key: '1-04',
                label: 'Tâches',
                icon: <ScheduleOutlined/>,
                page: <TaskList/>
            },
            {
                key: '1-03',
                label: 'Paramètres',
                icon: <SettingFilled/>,
                page: <Settings/>
            },
        ],
    },
    {
        key: '2',
        label: 'Compte',
        icon: <UserOutlined/>,
        children: [
            {
                key: '2-01',
                label: 'Mon compte',
                icon: <UserOutlined/>,
                page: <Account/>
            },
            {
                key: '2-02',
                label: 'Se déconnecter',
                icon: <LogoutOutlined/>
            },
        ],
    },
    {
        key: '3',
        label: 'Bac à sable',
        icon: <CodeSandboxOutlined/>,
        onlyAdmin: true,
        children: [
            {
                key: '3-01',
                label: 'Compteur',
                icon: <UserOutlined/>,
                page: <Counter min={0}/>
            },
            {
                key: '3-02',
                label: 'Portraits',
                icon: <UsergroupAddOutlined/>,
                page: <ShowPortraits/>
            },
        ],
    },
];

export default menuItems;

export const contentMap: Record<string, ReactNode> = {};

const collectPages = (items: MenuItem[]) => {
    for (const item of items) {
        if (item.page && item.key) {
            contentMap[item.key] = item.page;
        }
        if (item.children) {
            collectPages(item.children);
        }
    }
};

collectPages(menuItems);